export const campaignFeatureKey = 'campaign';

export type CampaignModel = {
  id: number;
  name: string;
  endDate: Date | null;
  startDate: Date | null;
};

export const ReferralCampaign = 1000000;
